import { apiAuthLogout } from '@/request/api';
import { clearStorage } from '@/utils';
import router from '@/router'

export default function outLogin() {
    apiAuthLogout();
    setTimeout(() => {
        clearStorage();
        router.replace(`/login`);
    }, 100)
}
